module.exports = __webpack_public_path__ + "static/media/ic-dragdrop-image.03a8a023.svg";